import React from 'react'

export default function SmallArrowLeftIcon({ ...props }) {
    return (
        <svg {...props} viewBox="0 0 16 17" fill="none" >
            <path d="M9.5 11.5L6.5 8.5L9.5 5.5" stroke="currentcolor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}